<script setup lang="ts">
import { ProfilePage } from '@yc/ui-kit'

import ChangePwdForm from '../components/ChangePwdForm.vue'
</script>

<!-- 个人信息卡与页面骨架都在 ui-kit 的 ProfilePage 里，这里只接本 app 的改密表单 -->
<template>
  <ProfilePage>
    <ChangePwdForm />
  </ProfilePage>
</template>
